import {FilterMatchMode} from 'primereact/api';
import {InputNumber} from 'primereact/inputnumber';
import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {withTranslation} from 'react-i18next';

class CriteriaInputNumberComponent extends Component {
    onChange(event, name) {
        event.name = name;
        if (this.props.onChange) {
            this.props.onChange(
                'NUMBER',
                undefined,
                event,
                FilterMatchMode.EQUALS,
                this.props.refreshFromBackend,
                this.props.onAfterStateChange
            );
        }
    }

    render() {
        const {
            disabled,
            colClass,
            id,
            keyfilter,
            label,
            min,
            max,
            name,
            placeholder,
            showLabel,
            showButtons,
            validator,
            validators,
            value,
            mode,
            locale,
            currency,
            minFractionDigits,
            maxFractionDigits,
        } = this.props;
        const required = validators !== undefined && validators.includes('required') && !validators.includes('not_required');
        return (
            <div className={colClass}>
                <div className='row'>
                    <div className='col-md-12 form-group'>
                        {label !== undefined ? (
                            // eslint-disable-next-line react/jsx-max-props-per-line
                            <label id={`${id}-label-id`} className='p-label' htmlFor={`${id}-input`} style={{width: '100%'}}>
                                {label}
                            </label>
                        ) : null}
                        <InputNumber
                            aria-describedby={`${id}-error`}
                            aria-label={label}
                            aria-labelledby={label === undefined && showLabel ? `${id}-label-id` : undefined}
                            key={id}
                            id={id}
                            name={name}
                            min={min}
                            max={max}
                            keyfilter={keyfilter}
                            placeholder={placeholder}
                            style={{width: '100%'}}
                            inputStyle={{width: '100%'}}
                            value={value}
                            onChange={(e) => this.onChange(e, name)}
                            disabled={disabled}
                            required={required}
                            showButtons={showButtons}
                            mode={mode}
                            locale={locale}
                            currency={currency}
                            minFractionDigits={minFractionDigits}
                            maxFractionDigits={maxFractionDigits}
                        />
                        <div aria-live='assertive'>{validator ? validator.message(id, label, value, validators) : null}</div>
                    </div>
                </div>
            </div>
        );
    }
}

CriteriaInputNumberComponent.defaultProps = {
    blackMode: false,
    colClass: 'col-xl-4 col-lg-6 col-md-6 col-sm-12',
    disabled: false,
    formGroup: true,
    iconSide: 'left',
    insideTable: false,
    min: undefined,
    max: undefined,
    placeholder: '',
    rendered: true,
    showLabel: true,
    showButtons: true,
    stateField: 'element',
    validateViewMode: false,
    validators: 'required',
    mode: 'decimal',
    refreshFromBackend: false,
};

CriteriaInputNumberComponent.propTypes = {
    blackMode: PropTypes.bool,
    colClass: PropTypes.string,
    disabled: PropTypes.bool,
    formGroup: PropTypes.bool,
    iconColor: PropTypes.string,
    iconName: PropTypes.string,
    iconSide: PropTypes.string,
    iconSize: PropTypes.string,
    id: PropTypes.string.isRequired,
    insideTable: PropTypes.bool,
    keyfilter: PropTypes.string,
    label: PropTypes.string.isRequired,
    min: PropTypes.number,
    max: PropTypes.number,
    name: PropTypes.string.isRequired,
    onAfterStateChange: PropTypes.func,
    onChange: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
    rendered: PropTypes.bool,
    showLabel: PropTypes.bool,
    showButtons: PropTypes.bool,
    stateField: PropTypes.string,
    validateViewMode: PropTypes.bool,
    validator: PropTypes.object.isRequired,
    validators: PropTypes.string,
    value: PropTypes.number,
    mode: PropTypes.string,
    locale: PropTypes.string,
    currency: PropTypes.string,
    minFractionDigits: PropTypes.number,
    maxFractionDigits: PropTypes.number,
    refreshFromBackend: PropTypes.bool,
};

export default withTranslation()(CriteriaInputNumberComponent);
